import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";

import { GqlCostSpecProtocol } from "~/__generated__";

type Props = {
    protocol: GqlCostSpecProtocol;
};

export default function ProjectCostProtocolDetails({ protocol }: Props) {
    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Duration</TableCell>
                    <TableCell>Hourly rate</TableCell>
                    <TableCell>Total</TableCell>
                    <TableCell>Total with travel</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {protocol.visits.map(visit => (
                    <TableRow key={visit.id}>
                        <TableCell>{visit.number}</TableCell>
                        <TableCell>{visit.minDuration}</TableCell>
                        <TableCell>{visit.pricePerHour}</TableCell>
                        <TableCell>{visit.total}</TableCell>
                        <TableCell>{visit.totalIncludingTravel}</TableCell>
                    </TableRow>
                ))}
                <TableRow>
                    <TableCell colSpan={3}></TableCell>
                    <TableCell>Total:</TableCell>
                    <TableCell>{protocol.total}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
}
